import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,HttpRequest } from "@angular/common/http";
import { AuthService } from 'src/app/services/auth/auth.service';
import { AppConfigService } from 'src/app/services/appconfig/app-config.service';
import { ErrorHandlerService } from '../error-handler/error-handler.service';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { AppInsightsService } from 'src/app/services/common/appinsights.service';

@Injectable({
  providedIn: 'root'
})
export class BulkRequestService {
private url: string;

  constructor(appConfigService: AppConfigService,
    private http: HttpClient,
    private appInsights: AppInsightsService) {
    
    this.url = appConfigService.get('apiUrl');
  }
 getBulkRequestHistory(clientId: string): Observable<any> {
  const params = { ClientID: clientId };
  return this.http.get(this.url +'/BillingAdjustment/GetBulkUploadHistoryDetails', { params }).pipe(
    map(response => response as any),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
}
getBulkUploadDetailsByAdjReqId(adjReqId: number): Observable<any> {
  return this.http.get(`${this.url}/BillingAdjustment/GetBulkUploadDetailsByAdjReqId/${adjReqId}`).pipe(
    map(response => response as any),
    catchError(error => {
      this.appInsights.logException(error);
      return throwError(() => error);
    })
  );
}


saveBulkRequests(jsonData:any): Observable<any> {
  return this.http.post(this.url + '/BillingAdjustment/BulkBillingAdjustmentRequest', jsonData).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
}
updateBulkRequest(payload: any): Observable<any> {
  return this.http.put(this.url + '/BillingAdjustment/UpdateBulkBillingAdjustmentRequest', payload).pipe(
    map(response => response as any),
    catchError(error => {
      this.appInsights.logException(error);
      return throwError(() => error);
    })
  );
}

cancelBulkRequest(adjReqId: number, cancelledBy: string): Observable<boolean> {
  const payload = {adjReqId,cancelledBy};
  return this.http.put<boolean>(this.url + '/BillingAdjustment/CancelBulkBillingAdjustmentRequest',payload).pipe(
    map(response => response as boolean),
    catchError(error => {
      this.appInsights.logException(error);
      return throwError(() => error);
    })
  );
}
getPendingBulkRequests(statusId: number): Observable<any> {
  return this.http.get(`${this.url}/BillingAdjustment/GetBulkBillingAdjustmentByStatus/${statusId}`).pipe(
    map(response => response as any),
    catchError(error => {
      this.appInsights.logException(error);
      return throwError(() => error);
    })
  );

  
}
getBulkRequestsByClientId(clientId: string): Observable<any> {
  return this.http.post(`${this.url}/BillingAdjustment/GetBulkBillingAdjustmentByCloudId`, {
    cloudId: clientId,
    statusId:0,
    startDate:null,
    endDate:null
  }).pipe(
    map(response => response as any),
    catchError(error => {
      this.appInsights.logException(error);
      return throwError(() => error);
    })
  );
}

getBulkRequestsApprovalHistory(requestBody: any): Observable<any> {
  return this.http.post(`${this.url}/BillingAdjustment/GetBulkBillingAdjustmentByCloudId`,requestBody).pipe(
    map(response => response as any),
    catchError(error => {
      this.appInsights.logException(error);
      return throwError(() => error);
    })
  );

  
}
updateBulkRequestStatus(payload: any): Observable<any> {
  return this.http.put(`${this.url}/BillingAdjustment/UpdateBulkBillingAdjustmentStatus`, payload).pipe(
    map((res: any) => res),
    catchError((error) => {
      this.appInsights.logException(error);
      return throwError(() => error);
    })
  );
}
getBulkBillingAdjustmentForGBS(requestBody: any): Observable<any> {
  return this.http.post(`${this.url}/BillingAdjustment/GetBulkBillingAdjustmentForGBS`, requestBody).pipe(
    map((response: any) => response),
    catchError(error => {
      this.appInsights.logException(error);
      return throwError(() => error);
    })
  );
}
UpdateBulkBillingAdjustmentStatusGBS(payload: any): Observable<any> {
  return this.http.put(`${this.url}/BillingAdjustment/UpdateBulkBillingAdjustmentStatusGBS`, payload).pipe(
    map((response: any) => response),
    catchError(error => {
      this.appInsights.logException(error);
      return throwError(() => error);
    })
  );
}

uploadBillingAdjustmentRequestFiles(formData: FormData, adjId: any): Observable<any> {
  const headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');

  return this.http.post(
    this.url + '/BillingAdjustment/InsertBillingAdjustmentRequestUpload?AdReqId=' + adjId,
    formData,
    { headers }
  ).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
}
uploadEditBillingAdjustmentRequestFiles(formData: FormData): Observable<any> {
  var headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
   
  return this.http.post(this.url + '/BillingAdjustment/EditBillingAdjustmentRequestUpload', formData, {
 headers: headers
  } ).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
}

DownloadTemplate(): Observable<Blob> {
  return this.http.get(this.url + '/BillingAdjustment/DownloadTemplate', {
    responseType: 'blob' 
  }).pipe(
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response); 
    })
  );
}
getBulkReportByDateRange(requestBody: any): Observable<any> {
  return this.http.post(`${this.url}/Reports/GetBulkReportByDateRange`, requestBody).pipe(
    map((response: any) => response),
    catchError(error => {
      this.appInsights.logException(error);
      return throwError(() => error);
    })
  );
}



}
